import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-navy text-navy-100 mt-24">
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 grid md:grid-cols-2 lg:grid-cols-5 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-2">
                        <div className="h-9 w-9 rounded-full bg-gold flex items-center justify-center">
                            <Heart className="h-4 w-4 text-navy" strokeWidth={2} />
                        </div>
                        <div className="font-serif text-2xl text-white">HolyMarry</div>
                    </div>
                    <p className="mt-4 text-sm text-navy-200 max-w-md leading-relaxed font-sans">
                        A Christ-centered matrimonial sanctuary for Orthodox Christians worldwide.
                        Built with reverence for sacred vows and the divine institution of marriage.
                    </p>
                </div>

                <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-gold font-semibold mb-4">Orthodox Network</div>
                    <ul className="space-y-2 text-sm font-sans">
                        <li>
                            <a href="https://www.orthodoxtv.in" target="_blank" rel="noopener noreferrer" data-testid="footer-orthodoxtv-link" className="hover:text-gold transition-colors inline-flex items-center gap-1.5">
                                Orthodox TV <span className="text-[10px] text-gold-300/70">↗</span>
                            </a>
                        </li>
                        <li><a href="https://www.orthodoxtv.in/?cat=29" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">Latest News</a></li>
                        <li><a href="https://www.orthodoxtv.in/?cat=27" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">Church News</a></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-gold font-semibold mb-4">Platform</div>
                    <ul className="space-y-2 text-sm font-sans">
                        <li><Link to="/search" className="hover:text-gold transition-colors">Browse Profiles</Link></li>
                        <li><Link to="/register" className="hover:text-gold transition-colors">Register Free</Link></li>
                        <li><Link to="/premium" className="hover:text-gold transition-colors">Premium Plans</Link></li>
                        <li><Link to="/login" className="hover:text-gold transition-colors">Sign In</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-gold font-semibold mb-4">Trust &amp; Safety</div>
                    <ul className="space-y-2 text-sm font-sans">
                        <li><a href="#" className="hover:text-gold transition-colors">Privacy Policy</a></li>
                        <li><a href="#" className="hover:text-gold transition-colors">Verified Profiles</a></li>
                        <li><a href="#" className="hover:text-gold transition-colors">Community Guidelines</a></li>
                        <li><a href="mailto:hello@holymarry.com" className="hover:text-gold transition-colors">hello@holymarry.com</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-navy-700/40">
                <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-navy-300 font-sans">
                    <div>© {new Date().getFullYear()} HolyMarry. All rights reserved.</div>
                    <div className="tracking-[0.15em] uppercase text-gold-300/60">&ldquo;Therefore what God has joined together, let no one separate&rdquo; — Mark 10:9</div>
                </div>
            </div>
        </footer>
    );
}
